'use strict';

var loadingCtrl = [function() {

}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {},
        controller: loadingCtrl,
        controllerAs: 'ctrl',
        templateUrl: 'loading-directive/loadingDirective.html'
    };
};
